module.exports = __webpack_public_path__ + "img/arrow-login-right-alt.9e42000f.svg";